import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { $errorSduiRequests, clearError } from '../../models/detail-sdui';

export const ErrorSduiRequestMessage = () => {
  const { t } = useTranslation();
  const [error] = useUnit([$errorSduiRequests]);

  if (!error) return null;

  return (
    <Dialog onClose={() => clearError()} open={!!error}>
      <DialogTitle>{t('Error')}</DialogTitle>

      <DialogContent>
        <DialogContentText>{error?.message ?? t('DataLoadingError')}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => clearError()}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
